/* eslint-disable react/no-unescaped-entities */
import React, { useMemo, useState } from 'react';
import { Button, Spin, message, Select, Icon } from 'antd';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from '@apollo/client';
import {
  UPDATE_PARTNER_PROMOTION,
  QUERY_PROMOTION_PLANS,
  CREATE_PARTNER_PROMOTION,
} from '~pages/dashboard/referral/partner-account/queries';
import { dayFormatType, formatDay } from '~helpers/day';

function PromotionEditor({
  country,
  partnerId,
  params,
  seletedPromotionId,
  paymentPreference,
  onClose,
}) {
  const { t } = useTranslation();
  const [promotionId, setPromotionId] = useState(seletedPromotionId);

  const { commissionLoading, data: commissionPlanListResponse } = useQuery(QUERY_PROMOTION_PLANS, {
    variables: {
      pageNumber: 1,
      pageSize: 999,
      countryCode: country,
      paymentPreferences: Array.from(new Set(['NOT_SPECIFIC', paymentPreference])),
      sortBy: [
        { sortField: 'DEFAULT', sortDirection: 'DESCENDING' },
        { sortField: 'UPDATED_AT', sortDirection: 'DESCENDING' },
      ],
    },
    onError: e => {
      message.error(e?.toString());
    },
    fetchPolicy: 'no-cache',
  });
  const commissionPlanList = useMemo(() => {
    return commissionPlanListResponse?.referralCommissionPlans?.edges || [];
  }, [commissionPlanListResponse]);

  const [updatePartnerPromotion, { loading: updatePartnerPromotionLoading }] = useMutation(
    UPDATE_PARTNER_PROMOTION,
    {
      onError: e => {
        message.error(e.message);
      },
    },
  );
  const [createPartnerPromotion, { loading: createPartnerPromotionLoading }] = useMutation(
    CREATE_PARTNER_PROMOTION,
    {
      onError: e => {
        message.error(e.message);
      },
    },
  );
  const handleSubmit = async () => {
    if (params?.id) {
      const response = await updatePartnerPromotion({
        variables: {
          input: {
            id: params?.id,
            referralCommissionPlanId: promotionId,
          },
        },
      });
      if (response?.data?.updatePartnerPromotion) {
        message.success('Update Partner  Promotion Success');
        onClose();
      }
    } else {
      const response = await createPartnerPromotion({
        variables: {
          input: {
            partnerId: partnerId,
            referralCommissionPlanId: promotionId,
          },
        },
      });
      if (response?.data?.createPartnerPromotion) {
        message.success('Create Partner  Promotion Success');
        onClose();
      }
    }
  };

  return (
    <>
      <div className="partner-register-city-editor__body" style={{ marginTop: '8px' }}>
        <section className="partner-register-city-editor__section">
          {commissionLoading ? (
            <div className="partner-register-city-editor__spin">
              <Spin />
            </div>
          ) : (
            <main className="partner-register-city-editor__main ">
              <div className="">
                <div className="tooltip-wrapper">
                  <Icon
                    type="exclamation-circle"
                    theme="filled"
                    style={{ color: '#f9a600', marginRight: 8 }}
                  />
                  <div className="tooltip">
                    Once a promotion is assigned to a specific partner, it won't be available for
                    other partners unless explicitly assigned to them.
                  </div>
                </div>

                <h3 className="partner-account-selector-title" style={{ marginTop: '24px' }}>
                  Promotion Name
                </h3>
                <Select
                  showSearch
                  className="partner-register-city-editor__selector"
                  onChange={value => {
                    setPromotionId(value);
                  }}
                  value={promotionId || undefined}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder={'Select Promotion'}
                >
                  {commissionPlanList?.map(item => (
                    <Select.Option value={item?.node?.id}>{item?.node?.name}</Select.Option>
                  ))}
                </Select>
              </div>
              <If condition={promotionId}>
                <PromotionDescription dataList={commissionPlanList} seleted={promotionId} />
              </If>
            </main>
          )}
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>

        <Button
          type="primary"
          size="large"
          htmlType="submit"
          className="partner-register-city-editor__save-button"
          loading={createPartnerPromotionLoading || updatePartnerPromotionLoading}
          onClick={handleSubmit}
        >
          {t('cms.referral.partner.detail.editor.btn.save')}
        </Button>
      </div>
    </>
  );
}

const PromotionDescription = ({ dataList, seleted }) => {
  const data = dataList?.find(item => item?.node?.id === seleted)?.node;

  return (
    <div className="partner-account-payoutplan">
      <div className="line">Applied Country: {data?.country?.name}</div>
      <div className="line">
        Valid Date: {formatDay(dayFormatType.UKFORMAT, data?.validDateFrom)} -{' '}
        {formatDay(dayFormatType.UKFORMAT, data?.validDateTo)}
      </div>
      <div className="line">Long Term (CNY):{data?.tiers[0]?.longTermCalculationValue}</div>
      <div className="line">Short Term (CNY): {data?.tiers[0]?.shortTermCalculationValue}</div>
    </div>
  );
};

export default PromotionEditor;
